export default {"src":"/_next/static/media/search.9a6f574f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};